// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecondBlock_root__K69VB {
  min-height: calc(100vh - 200px);
  padding: 40px 0;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH {
  display: flex;
  justify-content: space-between;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp {
  padding: 0 20px;
  color: #fff;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_titleSubtitleBlock__PeUBk .SecondBlock_titleBlock__iyCCi {
  font-size: 26px;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_titleSubtitleBlock__PeUBk .SecondBlock_subtitleBlock__DHnpe {
  font-size: 18px;
  color: #d71921;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_listItemBlock__Q-Rey {
  margin: 20px 0;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_listItemBlock__Q-Rey:last-child {
  margin-bottom: 0;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_listItemBlock__Q-Rey li {
  margin-left: 20px;
  list-style: circle;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf {
  padding: 0 20px;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf img {
  border-radius: 20px;
  border: none;
}
.SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 {
  margin-top: 20px;
}

@media (max-width: 991px) {
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH {
    flex-direction: column-reverse;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp {
    margin-top: 20px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf {
    padding: 0 20px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 25px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 {
    margin-top: 14px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 img {
    width: 100%;
    height: 180px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 img:first-child {
    margin-right: 10px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 img:last-child {
    margin-left: 10px;
  }
}
@media (max-width: 768px) {
  .SecondBlock_root__K69VB {
    padding: 20px 0;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp {
    font-size: 14px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_titleSubtitleBlock__PeUBk .SecondBlock_titleBlock__iyCCi {
    font-size: 18px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_titleSubtitleBlock__PeUBk .SecondBlock_subtitleBlock__DHnpe {
    font-size: 16px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf {
    padding: 0 20px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf img {
    height: 120px;
    border-radius: 20px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 img {
    height: 70px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 img:first-child {
    margin-right: 7px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_imagesBlock__4TmMf .SecondBlock_imgFlexBlock__88E22 img:last-child {
    margin-left: 7px;
  }
}
@media (max-width: 500px) {
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp {
    font-size: 12px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_titleSubtitleBlock__PeUBk .SecondBlock_titleBlock__iyCCi {
    font-size: 16px;
  }
  .SecondBlock_root__K69VB .SecondBlock_wrapper__HpCzH .SecondBlock_infoBlock__\\+jtHp .SecondBlock_titleSubtitleBlock__PeUBk .SecondBlock_subtitleBlock__DHnpe {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InfrastructureBlock/SecondBlock/SecondBlock.module.scss"],"names":[],"mappings":"AAAA;EACC,+BAAA;EACA,eAAA;AACD;AACC;EACC,aAAA;EACA,8BAAA;AACF;AACE;EACC,eAAA;EACA,WAAA;AACH;AAEI;EACC,eAAA;AAAL;AAGI;EACC,eAAA;EACA,cAAA;AADL;AAKG;EACC,cAAA;AAHJ;AAKI;EACC,gBAAA;AAHL;AAMI;EACC,iBAAA;EACA,kBAAA;AAJL;AASE;EACC,eAAA;AAPH;AASG;EACC,mBAAA;EACA,YAAA;AAPJ;AAUG;EACC,gBAAA;AARJ;;AAcA;EAEE;IACC,8BAAA;EAZD;EAcC;IACC,gBAAA;EAZF;EAeC;IACC,eAAA;EAbF;EAeE;IACC,WAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EAbH;EAgBE;IACC,gBAAA;EAdH;EAgBG;IACC,WAAA;IACA,aAAA;EAdJ;EAgBI;IACC,kBAAA;EAdL;EAiBI;IACC,iBAAA;EAfL;AACF;AAuBA;EACC;IACC,eAAA;EArBA;EAwBC;IACC,eAAA;EAtBF;EAyBG;IACC,eAAA;EAvBJ;EA0BG;IACC,eAAA;EAxBJ;EA6BC;IACC,eAAA;EA3BF;EA6BE;IACC,aAAA;IACA,mBAAA;EA3BH;EA+BG;IACC,YAAA;EA7BJ;EA+BI;IACC,iBAAA;EA7BL;EAgCI;IACC,gBAAA;EA9BL;AACF;AAsCA;EAGG;IACC,eAAA;EAtCF;EAyCG;IACC,eAAA;EAvCJ;EA0CG;IACC,eAAA;EAxCJ;AACF","sourcesContent":[".root {\n\tmin-height: calc(100vh - 200px);\n\tpadding: 40px 0;\n\n\t.wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\n\t\t.infoBlock {\n\t\t\tpadding: 0 20px;\n\t\t\tcolor: #fff;\n\n\t\t\t.titleSubtitleBlock {\n\t\t\t\t.titleBlock {\n\t\t\t\t\tfont-size: 26px;\n\t\t\t\t}\n\n\t\t\t\t.subtitleBlock {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tcolor: #d71921;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.listItemBlock {\n\t\t\t\tmargin: 20px 0;\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\n\t\t\t\tli {\n\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\tlist-style: circle;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.imagesBlock {\n\t\t\tpadding: 0 20px;\n\n\t\t\timg {\n\t\t\t\tborder-radius: 20px;\n\t\t\t\tborder: none;\n\t\t\t}\n\n\t\t\t.imgFlexBlock {\n\t\t\t\tmargin-top: 20px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 991px) {\n\t.root {\n\t\t.wrapper {\n\t\t\tflex-direction: column-reverse;\n\n\t\t\t.infoBlock {\n\t\t\t\tmargin-top: 20px;\n\t\t\t}\n\n\t\t\t.imagesBlock {\n\t\t\t\tpadding: 0 20px;\n\n\t\t\t\timg {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 180px;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\tborder-radius: 25px;\n\t\t\t\t}\n\n\t\t\t\t.imgFlexBlock {\n\t\t\t\t\tmargin-top: 14px;\n\n\t\t\t\t\timg {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\theight: 180px;\n\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 768px) {\n\t.root {\n\t\tpadding: 20px 0;\n\n\t\t.wrapper {\n\t\t\t.infoBlock {\n\t\t\t\tfont-size: 14px;\n\n\t\t\t\t.titleSubtitleBlock {\n\t\t\t\t\t.titleBlock {\n\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.subtitleBlock {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.imagesBlock {\n\t\t\t\tpadding: 0 20px;\n\n\t\t\t\timg {\n\t\t\t\t\theight: 120px;\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t}\n\n\t\t\t\t.imgFlexBlock {\n\t\t\t\t\timg {\n\t\t\t\t\t\theight: 70px;\n\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tmargin-right: 7px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-left: 7px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 500px) {\n\t.root {\n\t\t.wrapper {\n\t\t\t.infoBlock {\n\t\t\t\tfont-size: 12px;\n\n\t\t\t\t.titleSubtitleBlock {\n\t\t\t\t\t.titleBlock {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.subtitleBlock {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SecondBlock_root__K69VB`,
	"wrapper": `SecondBlock_wrapper__HpCzH`,
	"infoBlock": `SecondBlock_infoBlock__+jtHp`,
	"titleSubtitleBlock": `SecondBlock_titleSubtitleBlock__PeUBk`,
	"titleBlock": `SecondBlock_titleBlock__iyCCi`,
	"subtitleBlock": `SecondBlock_subtitleBlock__DHnpe`,
	"listItemBlock": `SecondBlock_listItemBlock__Q-Rey`,
	"imagesBlock": `SecondBlock_imagesBlock__4TmMf`,
	"imgFlexBlock": `SecondBlock_imgFlexBlock__88E22`
};
export default ___CSS_LOADER_EXPORT___;
